export default class Post {
  constructor({
    localFile,
    localUrl,
    localId,
    id,
    caption,
    small,
    medium,
    original
  } = {}) {
    this.localFile = localFile || null;
    this.localUrl = localUrl || null;
    this.localId = localId || null;
    this.id = id || null;
    this.caption = caption || null;
    this.small = small || null;
    this.medium = medium || null;
    this.original = original || null;
  }
}
